<!--MAIN-->

<div [class]="'dock-wrapper '+ mainSize">
    <div class="bg-image bg-{{skin}}"></div>

    <!--HEADER-->
    <header [class]="mainSize">
        <div [class]="'logo ' + mainSize"></div>

        <div class="tools-container">
            <a class="login" href="/account"><button class="button button-3d nomargin" name="login"
                                       routerLink="/account">login</button></a>
            <!--<div class="lang">-->
            <!--<button class="button button-3d nomargin compact"  name="en-lng" (click)="showEng($event)">-->
            <!--<div class="flag en"></div>-->
            <!--<div class="lng-text">en</div>-->
            <!--</button>-->
            <!--</div>-->
        </div>

        <text-carusel [class]="'text-carusel ' + mainSize" [mode]="dockSize"></text-carusel>
    </header>


    <!--ICONS-->

    <nav [class]="'home ' + dockSize" [style.bottom]='dockBottom'>

        <div [class]="'minilogo ' + mainSize"></div>

        <!-- иконки -->
        <div [class]="'icons-wrapper ' + dockSize + ' home'">
            <div *ngFor="let icon of iconList; let odd=odd;">

                <!--пузыри-->
                <a *ngIf="icon.mode == 'bubble' && icon.class != 'home'
                    && !(icon.class == 'social' && dockSize == 'full')
                    && !(icon.class == 'calculator' && (dockSize == 'full' || dockSize == 'medium'))"

                     [class]="icon.mode + ' ' + mainSize + ((odd)? ' even' : ' odd') "
                     routerLink="{{icon.routerLink}}" routerLinkActive="active"
                     href="{{icon.routerLink}}" target="_self"
                     [style.top.px]='icon.y' [style.left.px]='icon.x'>

                    <div class="icon-item">
                        <div class="icon-bubble icon-bubble-{{skin}}"></div>
                        <div class="item-img {{icon.class}}" (mousedown)="onPush($event, icon)"></div>
                             <!--(mouseup)="onMouseUp($event, icon)"></div>-->
                    </div>
                    <div [class]="'text_container ' + mainSize ">
                        <div class="text"><p [innerHTML]="'Dock.'+icon.class | translate"></p></div>
                    </div>
                </a>


                <!--линзы-->
                <a *ngIf="icon.mode == 'lens'"
                     [class]="icon.mode + ' ' + mainSize + ((odd)? ' odd' : ' even') "
                     href="{{icon.routerLink}}" target="_self"
                     routerLink="{{icon.routerLink}}"
                     routerLinkActive="active">
                    <div class="icon-item" (mousedown)="onPush($event, icon)">
                        <div class="icon-bubble icon-bubble-{{skin}}"></div>
                        <div class="item-img {{icon.class}}"></div>
                    </div>
                    <div class="text"><p [innerHTML]="'Dock.'+icon.class+'Descr' | translate"></p></div>
                </a>

            </div>
        </div>

        <div [class]="'more-navigation ' + dockSize" *ngIf="dockSize != 'full' && dockSize != 'medium'">
            <div class="more-navigation-btn" (click)="onClickMoreBtn()">
                {{'BTN.More' | translate}}
            </div>
        </div>


    </nav>

    <!--социальные иконки-->
    <div class="dock-footer" *ngIf="dockSize == 'full' || dockSize == 'medium'">
        <div class="desk"></div>
        <div class="social-container" *ngIf="socialList">
            <a *ngFor="let sIcon of socialList" [class]="'social-icons-item ' + sIcon.class" href="{{sIcon.routerLink}}"
               target="_blank" (mousedown)="onPush($event, sIcon)">
                <div *ngIf="skin=='snow'" class="social-item-snow-cap"></div>
            </a>
            <a [class]="'social-icons-item calculator'" href="/sms-calculator" routerLink="/sms-calculator">
                <div *ngIf="skin=='snow'" class="social-item-snow-cap"></div>
            </a>
        </div>


<!--        <div [class]="'privacy-navigation ' + dockSize" *ngIf="dockSize == 'full' || dockSize == 'medium'">-->
<!--            <div class="privacy-navigation-btn">-->
<!--                {{'BTN.More' | translate}}-->
<!--            </div>-->
<!--            &lt;!&ndash;            <a href="/information-security" routerLink="/information-security" class="privacy-navigation-btn">&ndash;&gt;-->
<!--            &lt;!&ndash;                {{'Privacy.InformationBtn' | translate}}&ndash;&gt;-->
<!--            &lt;!&ndash;            </a>&ndash;&gt;-->
<!--        </div>-->

        <div [class]="'more-navigation ' + dockSize">
            <div class="more-navigation-btn" (click)="onClickMoreBtn()">
                {{'BTN.More' | translate}}
            </div>
        </div>



    </div>

    <div [class]="'more-panel ' + dockSize" [ngClass]="{show: showMorePanel}">
        <div class="more-navigation-close-btn" *ngIf="dockSize != 'full' && dockSize != 'medium'"
             (click)="onCloseMorePanel()">
            <i class="icon icon-line-cross"></i>
        </div>
        <a href="/privacy-notice" routerLink="/privacy-notice" class="more-panel-item" (click)="onCloseMorePanel()">
            {{'Privacy.PrivacyBtn' | translate}}
        </a>
        <a href="/information-security" routerLink="/information-security" class="more-panel-item" (click)="onCloseMorePanel()">
            {{'Privacy.InformationBtn' | translate}}
        </a>
        <a href="/sms-calculator" routerLink="/sms-calculator" class="more-panel-item" (click)="onCloseMorePanel()">
            {{'SMSCalculator.Title' | translate}}
        </a>
    </div>



    <cat [skin]="skin" *ngIf="dockSize == 'full' || dockSize == 'medium'"></cat>


</div>


